import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insurance-policy',
  templateUrl: './insurance-policy.component.html',
  styleUrls: ['./insurance-policy.component.scss']
})
export class InsurancePolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
